import React from 'react';
import PropTypes from 'prop-types';

const WrittenComprehensionStatusHeader = ({ result, index }) => {
    const { proficient: isProficient, score, maxScore } = result;
    return (
        <div className="paragraph-holder" key={index}>
            <p>
                <span>{`Question ${index + 1}: `}</span>
                <span className={isProficient ? 'green' : 'red'}>
                    {isProficient ? 'Proficient' : 'Not Proficient'}, {`${score}/${maxScore}`}
                </span>
            </p>
        </div>
    );
};

WrittenComprehensionStatusHeader.defaultProps = {
    result: {},
    index: 0,
};

WrittenComprehensionStatusHeader.propTypes = {
    result: PropTypes.object,
    index: PropTypes.number,
};

export default WrittenComprehensionStatusHeader;
